import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["component", "render"];
import React from 'react';
/* eslint-disable-next-line no-restricted-imports */

import { Route } from 'react-router-dom';
import RouterContext from "./RouterContext";
/* eslint-disable-next-line no-restricted-imports */

/**
 * Wraps react-router's Route children with context to support hooks (useLocation, useParams etc).
 * Check ./hooks/index.js for the hooks implemetation.
 */
export const RouteWithContext = props => {
  const {
    component: Component,
    render: _render
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement(Route, _extends({}, rest, {
    render: routeProps => {
      return /*#__PURE__*/React.createElement(RouterContext.Provider, {
        value: {
          location: routeProps.location,
          history: routeProps.history,
          match: routeProps.match
        }
      }, _render ? _render(routeProps) : Component ? /*#__PURE__*/React.createElement(Component, routeProps) : null);
    }
  }));
};